<template>
    <div>
        <p v-if="!loaded && !error" class="text-center">
            <span class="loading-spinner loading-spinner-big loading-spinner-green"></span>
            <span class="sr-only">Loading...</span>
        </p>
        <div class="flex animated fadeIn" v-if="challengeRequest.loaded && error">
          <img class="icon" src="https://res.cloudinary.com/dspi5zyaa/image/upload/v1643639005/eh-platform/icons/smashicons_website_elements_website-error-28-icon-cartoony.svg">
          <span>Statistiken konnten nicht geladen werden.</span>
        </div>
      <div v-if="isAuthenticated && yourRate && loaded && !error" class="col-xs-12 col-lg-9" style="padding: 0">
        <h3 class="statistics-title">
          Deine Rank the Code Statistiken
        </h3>
        <div v-if="rankTheCodeStatistics.loaded && !rankTheCodeStatistics.error">
          <div class="col-xs-12 col-md-6  animated fadeIn">
            <div class="statistics-container">
              <div class="icon-container">
                <img src="https://res.cloudinary.com/dspi5zyaa/image/upload/v1641904218/eh-platform/icons/smashicons_survey_and_ratings_customer-rating-icon-16-cartoony_1.svg" class="statistics-icon"/>
              </div>
              <div class="statistics-text clearfix">
                <div style="padding-left: 1rem;">
                  <strong>
                    Bewertungen
                  </strong>
                  <br/>
                  <div v-if="rankTheCodeStatistics.apiData.quantityOfRatings > 0" class="statistics-rating">
                    <star-rating size="1.6rem" :disabled="true" name="rate"
                                 :value="rankTheCodeStatistics.apiData.averageRating">
                    </star-rating>
                    <span class="statistics-rating-text">
                    {{rankTheCodeStatistics.apiData.averageRating.toFixed(1)}}  ({{rankTheCodeStatistics.apiData.quantityOfRatings}})
                  </span>
                  </div>
                  <p v-if="rankTheCodeStatistics.apiData.quantityOfRatings <= 0">Noch keine Bewertungen</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-6  animated fadeIn">
            <div class="statistics-container">
              <div class="icon-container">
                <img src="https://res.cloudinary.com/dspi5zyaa/image/upload/v1641904550/eh-platform/icons/smashicons_feedback_feeback-rising-icon-17-cartoony_1.svg" class="statistics-icon"/>
              </div>
              <div class="statistics-text clearfix">
                <div style="padding-left: 1rem;">
                  <strong>
                    Kommentare
                  </strong>
                  <br/>
                  <span v-if="rankTheCodeStatistics.apiData.quantityOfComments > 0" class="statistics-count">
                    {{rankTheCodeStatistics.apiData.quantityOfComments}}
                </span>
                  <p v-if="rankTheCodeStatistics.apiData.quantityOfComments <= 0">Noch keine Kommentare</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="rankTheCodeStatistics.loaded && rankTheCodeStatistics.error" class="error-message">
          <img class="icon" src="https://res.cloudinary.com/dspi5zyaa/image/upload/v1643639005/eh-platform/icons/smashicons_website_elements_website-error-28-icon-cartoony.svg">
          <span>Deine Rank the Code Statistiken konnten nicht geladen werden.</span>
        </div>
      </div>


        <div v-if="loaded && !error" class="col-md-12 col-lg-9 col-sm-12 col-xs-12" style="padding: 0">
            <h3 class="statistics-title">
                Statistiken für die {{technologyDisplayNameShort}} Challenge
            </h3>
            <div class="col-xs-12 col-md-6  animated fadeIn">
                <div class="statistics-container" :class="{inactive: !yourRate}">
                    <div class="icon-container">
                        <img src="/assets/icons/submission-metrics/speed.png" class="statistics-icon"
                             style="transform: translateY(-50%) translateX(-54%);"/>
                    </div>
                    <div class="statistics-text clearfix">
                        <div style="padding-left: 1rem;">
                            <strong>Deine Lösung</strong>
                            <div v-if="isAuthenticated">
                                <p v-if="yourRate && yourRate.isRankOne && yourRate.percentagePosition !== null">Du hast die <strong>beste</strong>
                                    Lösung!</p>
                                <p v-if="yourRate && !yourRate.isRankOne && yourRate.percentagePosition !== null">Du bist unter den
                                    besten <strong>{{Math.round(yourRate.percentagePosition * 100)}}%</strong></p>
                                <p v-if="yourRate && yourRate.percentagePosition === null"><strong>50%</strong> sind
                                    genau so gut wie du!</p>
                            </div>
                            <p v-if="!yourRate" class="">Löse die Challenge und finde heraus, wie gut du bist!</p>

                        </div>
                    </div>
                </div>
            </div>

            <div class="col-xs-12 col-md-6  animated fadeIn">
                <div class="statistics-container" :class="{inactive: !firstSolutionExists}">
                    <div class="icon-container">
                        <img src="/assets/icons/submission-metrics/fast.svg" class="statistics-icon"
                             style="transform: translateY(-50%) translateX(-54%);"/>
                    </div>
                    <div class="statistics-text clearfix">
                        <div style="padding-left: 1rem;">
                            <strong>
                                Erste Abgabe
                            </strong>
                            <br/>
                            <p v-if="!firstSolutionExists && isAuthenticated">Du hast die Chance der erste zu sein!</p>
                            <p v-if="!firstSolutionExists && !isAuthenticated"><a href="#" @click="logInAndComeHereAgain">Melde dich an</a> und sieh wer der erste war!</p>
                            <router-link  v-if="firstSolutionExists" class="username-wrap"
                                    :to="{ name: 'public-user-profile', params: { userId: challengeStatistics.publicUserIdOfFirstSolution }}">
                                <img width="30"
                                     class="metrics-icon"
                                     style="border-radius: 50%; height: 30px; width:auto;"
                                     :src="profilePictureFirstSolution"
                                     :alt="'Profile image of the user ' + displayNameFirstSolution"/>&nbsp;{{displayNameFirstSolution}}

                            </router-link>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-xs-12 col-md-6  animated fadeIn">
                <div class="statistics-container">
                    <div class="icon-container">
                        <img src="/assets/icons/submission-metrics/crowd.png" class="statistics-icon"/>
                    </div>
                    <div class="statistics-text clearfix">
                        <div style="padding-left: 1rem;">
                            <strong>
                                Anzahl Annahmen
                            </strong>
                            <br/>
                            <span class="statistics-count">
                    {{challengeStatistics.acceptancesCount}}
                        </span>
                        </div>
                    </div>
                </div>
            </div>


            <div class="col-xs-12 col-sm-12 col-md-6  animated fadeIn">
                <div class="statistics-container">
                    <div class="icon-container">
                        <img src="/assets/icons/submission-metrics/star.svg" class="statistics-icon"
                             style="opacity: .7"/>
                    </div>
                    <div class="statistics-text clearfix">
                        <div style="padding-left: 1rem;">
                            <strong>
                                Vollständige Lösungen
                            </strong>
                            <br/>
                            <span class="statistics-count">
                    {{challengeStatistics.solutionsCount}}
                        </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="loaded && !error" class="col-xs-12 col-xs-offset-0 col-lg-3 col-sm-12 col-sm-offset-0 col-md-offset-0 col-sm-12 col-md-12 ">
            <div v-if="challengeStatistics.acceptancesCount!==0">
                <div class="" style="position: relative; width: 100%; ">

                    <svg viewBox="0 0 36 36" class="circular-chart">
                        <path class="circle-background"
                              stroke-dasharray="100, 100"
                              d="M18 2.0845
                          a 15.9155 15.9155 0 0 1 0 31.831
                          a 15.9155 15.9155 0 0 1 0 -31.831"
                        />
                        <path class="circle"
                              :style="'stroke-dasharray: ' + solutionRate + ' 100;'"

                              d="M18 2.0845
                          a 15.9155 15.9155 0 0 1 0 31.831
                          a 15.9155 15.9155 0 0 1 0 -31.831"
                        />
                    </svg>
                    <div class="diagram-description">
                        <h3 class="text-center stats-heading">
                            <strong style="margin-right: 0.5rem; font-size: 4rem; font-weight: bolder;">{{solutionRate}}%</strong>
                            <br/>
                            <span>Erfolgsquote</span>
                        </h3>
                    </div>
                </div>
            </div>
        </div>


    </div>
</template>

<script>
    import {services} from "../../main";
    import {mapState} from "vuex";
    import {LANGUAGES} from "../../const";
    import StarRating from "../StarRating";

    export default {
        name: "SubmissionStatistics",
        components: {StarRating},
        props: {
            challengeId: {type: String, required: true},
        },
        data() {
            return {
                userProfileRequest: {loaded: false, error: null},
                challengeRequest: {loaded: false, error: null},
                firstSolutionDisplayNameRequest: {loaded: false, error: null},
                percentagePosition: {loaded: false, error: null},
                rankTheCodeStatistics: {loaded: false, error: null},
                ratingList: [],
                ratingsAllStagesList: []
            };
        },
        computed: {
            technologyDisplayNameShort: function() {
                let technology = this.challengeRequest.challenge_data.technology;
                let programmingLanguage = technology.language.toLocaleLowerCase();
                if (programmingLanguage === "") {
                    return this.name;
                }
                if (technology.name === "") {
                    return LANGUAGES[programmingLanguage];
                }
                return technology.name;
            },
            solutionRate: function () {
                if (this.challengeStatistics && this.challengeStatistics.acceptancesCount === 0) {
                    return 0;
                }
                return Math.round((this.challengeStatistics.solutionsCount / this.challengeStatistics.acceptancesCount) * 100);
            },
            ...mapState([
                'isAuthenticated',
            ]),
            displayNameFirstSolution: function () {
                if (this.firstSolutionDisplayNameRequest.loaded && !this.firstSolutionDisplayNameRequest.error) {
                    if (this.firstSolutionDisplayNameRequest.apiData.length !== 0 && this.firstSolutionDisplayNameRequest.apiData[0].displayName !== '') {
                        return this.firstSolutionDisplayNameRequest.apiData[0].displayName;
                    }
                }
                return "Anonymer EntwicklerHeld"
            },
            profilePictureFirstSolution: function () {
                if (this.firstSolutionDisplayNameRequest.loaded && !this.firstSolutionDisplayNameRequest.error) {
                    if (this.firstSolutionDisplayNameRequest.apiData.length !== 0 && this.firstSolutionDisplayNameRequest.apiData[0].profilePicture !== '')
                    return this.firstSolutionDisplayNameRequest.apiData[0].profilePicture;
                }
                return "https://s3.amazonaws.com/s3-cuescience/anonym-user.png"
            },
            yourRate: function () {
                if (this.percentagePosition.loaded && !this.percentagePosition.error && this.percentagePosition.apiData) {
                    return this.percentagePosition.apiData;
                }
            },
            firstSolutionRequestIsLoadedOrThereIsNoFirstSolution: function () {
                return this.firstSolutionDisplayNameRequest.loaded || typeof this.challengeStatistics.publicUserIdOfFirstSolution === 'undefined';
            },
            loaded: function () {
                if (this.isAuthenticated) {
                    return this.challengeRequest.loaded && this.percentagePosition.loaded && this.firstSolutionRequestIsLoadedOrThereIsNoFirstSolution;
                }
                return this.challengeRequest.loaded;
            },
            error: function () {
                return this.challengeRequest.error;
            },
            challengeStatistics: function () {
                return this.challengeRequest.challenge_data.statistics
            },
            firstSolutionExists: function () {
                if (this.challengeRequest.loaded && !this.challengeRequest.error) {
                    if (this.challengeRequest.challenge_data.statistics.publicUserIdOfFirstSolution) {
                        return true
                    }
                }
                return false;
            },
        },
        methods: {
          logInAndComeHereAgain: function () {
            services.auth.login({fullPath: this.$route.fullPath});
          },
        },
        watch: {
            "userProfileRequest.loaded": function () {
                if (this.userProfileRequest.loaded && !this.userProfileRequest.error) {
                    const region = this.userProfileRequest.user_profile.encoded_region;
                    this.challengeRequest = services.taskManagementService.getChallengeDetails(this.challengeId, region);
                }
            },
            "challengeRequest.loaded": function () {
                if (this.isAuthenticated && this.challengeRequest.loaded && !this.challengeRequest.error) {
                    if (this.challengeRequest.challenge_data.solved) {
                        this.percentagePosition = services.qualityService.getPercentagePosition(this.challengeId);
                    }
                    else {
                        this.percentagePosition = {error: false, loaded: true}
                    }

                    const publicUserIdOfFirstSolution = this.challengeStatistics.publicUserIdOfFirstSolution;
                    if (typeof publicUserIdOfFirstSolution !== 'undefined') {
                        this.firstSolutionDisplayNameRequest = services.userService.getDataForPublicUserIds(
                            [publicUserIdOfFirstSolution]
                        )
                    }
                }
            }
        },
        created() {
            if (this.isAuthenticated) {
                this.rankTheCodeStatistics = services.rankTheCodeService.getChallengeStatistics(this.challengeId);
                this.userProfileRequest = services.userService.getUserProfile();
            } else {
                this.challengeRequest = services.taskManagementService.getChallengeDetails(this.challengeId);
            }
        },
    }
</script>

<style scoped>
    .metric {
        max-width: 100%;
        border: rgba(0, 0, 0, 0.07) 1px solid;
        background: rgba(255, 255, 255, 0.8);
        border-radius: 2px;
        box-shadow: 0 10px 30px rgba(50, 50, 93, .1), 0 5px 10px rgba(0, 0, 0, .07);
    }

    .metric .dashboard-stats__title, .metric .dashboard-stats__title small {
        color: #2c3e50;
    }

    .metric i {
        color: #08AB99;
        opacity: 0.8;
    }

    i.metrics-icon {
        left: -3% !important;
    }

    .silver-panel:not(.inactive):hover {
        box-shadow: 0px 10px 22px 0px rgba(50, 50, 50, 0.19);
        -webkit-box-shadow: 0px 10px 22px 0px rgba(50, 50, 50, 0.19);
    }

    .silver-panel {
        background-color: var(--color-white);
        background: linear-gradient(135deg, var(--color-white), var(--color-light));
        border-radius: 1rem;
        box-sizing: border-box;
        padding: 3.5rem 2.5rem;
        flex: 1;
        box-shadow: 0px 10px 22px 0px rgba(50, 50, 50, 0.09);
        -webkit-box-shadow: 0px 10px 22px 0px rgba(50, 50, 50, 0.09);
        transition: all 300ms linear;
    }

    .stats-row {
        margin-bottom: 2rem;
    }

    .metrics-icon {
        min-width: 30px;
        width: 15%;
    }

    .user-picture {
        width: 4rem;
        height: 4rem;
        background-position: center center;
        background-size: contain;
        border-radius: 50%;
        color: transparent;
        margin-right: 10px;
        border: none !important;
        background-color: transparent;
        display: inline-block;
    }

    h3 {
        font-size: 1.6rem;
    }


    .circular-chart {
        display: block;
        margin: 10px auto;
        max-width: 80%;
        max-height: 250px;
    }

    .circle-background {
        stroke: #E4F0FB;
        fill: none;
        stroke-width: 2.8;
    }

    .circle {
        stroke: #08AB99;
        fill: none;
        stroke-width: 2.8;
        animation: progress 1s ease-out forwards;
        stroke-linecap: round;
    }

    @media (max-width: 1460px) and (min-width: 1200px) {
        .circular-chart {
            margin-top: 7rem;
        }
    }

    @media (max-width: 1700px) and (min-width: 1461px) {
        .circular-chart {
            margin-top: 4rem;
        }
    }

    @keyframes progress {
        0% {
            stroke-dasharray: 0 100;
        }
    }


    .stats-heading {
        font-family: "Source Code Pro", monospace;
        color: gray;
        margin: 0;
        font-size: 1.3rem;
    }

    .diagram-description {
        position: absolute;
        top: 50%;
        margin: auto;
        padding: 15px;
        left: 50%;
        transform: translate(-50%, -50%);
    }


    .statistics-container {
        height: 8rem;
        background: white;
        padding: 0;
        border-radius: 10px;
        box-sizing: border-box;
        margin-bottom: 1.5rem;
        margin-top: 1.5rem;
    }

    .icon-container {
        height: 8rem;
        width: 8rem;
        background: repeating-linear-gradient(#E4F0FB 0%, #CEE3F8 100%);
        border-radius: 10px 0 0 10px;
        position: relative;
        float: left;
    }

    .statistics-icon {
        width: 50px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translateY(-50%) translateX(-50%);
        filter: grayscale(.25);
    }

    .statistics-text {
        padding: 1.3rem;
        height: 8rem;
        float: left;
        width: calc(100% - 8rem);

    }
    .statistics-rating {
      display: flex;
    }

    .statistics-rating-text {
      margin-left: 1rem;
      font-size: 1.6rem;
      font-weight: bold;
    }

    ::v-deep .statistics-rating .star-rating__star {
      padding-left: 0;
    }

    .username-wrap {
        word-break: break-all;
    }
    .statistics-count {
        font-size: 25px;
        font-weight: 700;
    }

    .inactive {
        filter: grayscale(0.1);
        opacity: 0.5;
    }

    .statistics-title {
        font-size: 18px;
        margin-left: 1.5rem;
    }

    .error-message {
      padding: 1.5rem;
      display: flex;
      flex-direction: row;
      align-items: center;
    }
    .icon {
      height: 3rem;
      margin-right: 2rem;
    }
</style>
